module.exports = __webpack_public_path__ + "static/media/iphone_12_bottom.321cbf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/iphone_12_bottom.png
// module id = 1136
// module chunks = 0